import { render, staticRenderFns } from "./productAttributes.vue?vue&type=template&id=58cc4fcc&scoped=true&"
import script from "./productAttributes.vue?vue&type=script&lang=js&"
export * from "./productAttributes.vue?vue&type=script&lang=js&"
import style0 from "./productAttributes.vue?vue&type=style&index=0&id=58cc4fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cc4fcc",
  null
  
)

export default component.exports